import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import RenderIf from '../../../shared/render-if/components/render-if';
import copyImg from '../images/copy-to-clipboard.png';

import '../styles/copy-button.css';

class CopyButton extends Component {
  handleCopy(content, callback) {
    if (callback) {
      callback(content);
    }
  }

  render() {
    const { copyContent, callback, renderInput } = this.props;

    return (
      <div className="copy-button-container">
        <RenderIf if={renderInput}>
          <input disabled={true} className="copy-button-container__input" value={copyContent || ''} />
        </RenderIf>
        <CopyToClipboard text={copyContent || ''} onCopy={() => this.handleCopy(copyContent, callback)}>
          <button className="copy-button-container__copy-btn">
            <img src={copyImg} alt="Copy" />
          </button>
        </CopyToClipboard>
      </div>
    );
  }
}

export default CopyButton;



// WEBPACK FOOTER //
// ./src/app/shared/copy-button/components/copy-button.js